import React, {
  useEffect,
  useState,
} from "react";

import jwt_decode from "jwt-decode";

import {
  FaClipboardList,
} from "react-icons/fa";

import AddRemito from "../components/AddRemito";
import TableRemitos from "../components/TableRemitos";
import Footer from "../components/Footer";

import "../css/admin.css";
import "../css/remitos.css";

const Remitos = () => {
  const [
    usuario,
    setUsuario,
  ] = useState({});

  const [
    show,
    setShow,
  ] = useState(false);

  const token =
    localStorage.getItem("token");

  useEffect(() => {
    if (token) {
      try {
        const token_decode =
          jwt_decode(token);

        setUsuario(
          token_decode.usuario
        );
      } catch (e) {
        console.error(
          "❌ Error al decodificar token:",
          e
        );

        setUsuario({});
      }
    }
  }, [token]);

  return (
    <>
      <main className="rem2-page">
        {token ? (
          usuario?.role ===
          "ADMIN_ROLE" ? (
            <>
              <section className="rem2-header">
                <div className="rem2-header-icon">
                  <FaClipboardList />
                </div>

                <div className="rem2-header-text">
                  <span>
                    PAPAS
                  </span>

                  <h1>
                    Gestión de Remitos
                  </h1>

                  <p>
                    Registro y seguimiento de
                    remitos, proveedores, clientes,
                    kilos, precios y documentación.
                  </p>
                </div>
              </section>

              <div className="rem2-actions">
                <AddRemito
                  setShow={setShow}
                  show={show}
                />
              </div>

              <TableRemitos />
            </>
          ) : (
            <div
              className="alert alert-info"
              role="alert"
            >
              Lo sentimos, pero no tiene
              permisos para acceder a este
              contenido.
            </div>
          )
        ) : (
          <div
            className="alert alert-danger"
            role="alert"
          >
            No se encuentra logueado en la
            plataforma.
          </div>
        )}
      </main>

      <Footer />
    </>
  );
};

export default Remitos;